import client from "./config";

export async function getUsSignal() {
  const res = await client.get("v1/signal/getUsSignal");
  const result = res.data;
  return result;
}
